import MenuIcon from 'mdi-react/MenuIcon'
import React, { useCallback, useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { AppBar, Drawer, Hidden, IconButton, SwipeableDrawer, Theme, Toolbar, Typography } from '@mui/material'

import { SidebarContent } from './SidebarContent.component'

export type SidebarProps = ExtendableStyles & Testable

export function Sidebar(props: SidebarProps) {
  const { classes } = useStyles()
  const { show, handleOpenSidebar, handleCloseSidebar } = useSidebarData()
  const iOS = (process as any).browser && /iPad|iPhone|iPod/.test(navigator.userAgent)

  return (
    <>
      <Hidden mdUp>
        <SwipeableDrawer
          variant="temporary"
          anchor="left"
          open={show}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          onOpen={handleOpenSidebar}
          onClose={handleCloseSidebar}
          disableBackdropTransition={!iOS}
          disableDiscovery={iOS}
          {...props}
        >
          <SidebarContent />
        </SwipeableDrawer>
        <div className={classes.appBarPlaceholder} />
        <AppBar className={undefined}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="Open sidebar"
              onClick={handleOpenSidebar}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" color="inherit" noWrap>
              FounderNest
            </Typography>
          </Toolbar>
        </AppBar>
      </Hidden>
      <Hidden smDown implementation="css">
        <div className={classes.dockedDrawerRoot} {...props}>
          <div className={classes.dockerDrawerPlaceholder} />
          <Drawer
            variant="permanent"
            open
            classes={{
              docked: classes.dockedDrawer,
              paper: classes.drawerPaper,
            }}
          >
            <SidebarContent />
          </Drawer>
        </div>
      </Hidden>
    </>
  )
}

function useSidebarData() {
  const [show, setVisibility] = useState(false)
  const handleOpenSidebar = useCallback(() => {
    setVisibility(true)
  }, [])

  const handleCloseSidebar = useCallback(() => {
    setVisibility(false)
  }, [])

  return {
    show,
    handleCloseSidebar,
    handleOpenSidebar,
  }
}

const useStyles = makeStyles()(({ palette, breakpoints, spacing }: Theme) => {
  const drawerSize = {
    height: '100vh',
    width: spacing(38),
  }

  return {
    dockerDrawerPlaceholder: {
      ...drawerSize,
    },
    dockedDrawerRoot: {
      ...drawerSize,
    },
    dockedDrawer: {
      ...drawerSize,
      position: 'fixed',
      top: 0,
      left: 0,
    },
    drawerPaper: {
      background: palette.primary.dark,
      [breakpoints.up('md')]: {
        position: 'relative',
      },
      width: drawerSize.width,
    },
    appBarPlaceholder: {
      width: '100%',
      height: spacing(8),
    },
    menuButton: {
      marginRight: spacing(2),
    },
  }
})
